<app-header *ngIf="!router.url.includes('/brochure')"></app-header>
<router-outlet (activate)="onActivate()"></router-outlet>
<app-footer *ngIf="!router.url.includes('/brochure')"></app-footer>

